
const environment = {
    env: 'prod',
}

export default environment